export function fade() {
  // タイトル要素を取得
  let titles = document.querySelectorAll(".js-fade--item");

  // テキストを <span><span> でラップ
  titles.forEach((title) => {
    // 元のHTML構造を取得
    let originalHTML = title.innerHTML.trim();

    // HTML構造を <span><span> でラップ
    title.innerHTML = `<span>${originalHTML}</span>`;
  });

  // IntersectionObserver の設定
  const observerOptions = {
    root: null, // ビューポートを基準
    rootMargin: "0px",
    threshold: 1, // 100%が見えたら発火
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 対象要素にクラスを追加
        entry.target.classList.add("js-add-fade");
      }
    });
  }, observerOptions);

  // 各タイトル要素を監視対象に追加
  setTimeout(() => {
    titles.forEach((title) => {
      observer.observe(title);
    });
  }, 300);
}
